import { ChangeCandidateDto } from 'src/app/data-transfer/entities/change-candidate-dto';
import { ImportTypeSetting, PackagingImportHelper } from './packaging-import-helper';
import { Observable } from 'rxjs';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';
import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { PackagingUnitNavigationService } from 'src/app/navigation/services/navigation-services/packaging-unit-navigation.service';
import { ChangePackagingUnitCandidateDto } from 'src/app/data-transfer/entities/packaging-unit-entities/change-packaging-unit-candidate-dto';

export class PackagingUnitImportHelper implements PackagingImportHelper {
  constructor(
    private importExportApiService: ImportExportApiService,
    private packagingUnitNavigationService: PackagingUnitNavigationService
  ) {}

  getTableTitle(importType: ImportTypeSetting, archiveActive: boolean): string {
    if (importType === ImportTypeSetting.Import) {
      if(archiveActive) {
        return 'dataManagement.import.import.tableTitlePackagingUnitArchive';
      }
      return 'dataManagement.import.import.tableTitlePackagingUnit';
    }
    return 'dataManagement.import.changes.tableTitlePackagingUnit';
  }

  getDisplayedColumns(): string[] {
    return ['itemId', 'version', 'exportingOrganization', 'packagingTypeName', 'brandName', 'productName', 'articleNumber', 'timestamp', 'action', 'select'];
  }

  getPackagingImportCandidates(): Observable<ImportCandidateDto[]> {
    return this.importExportApiService.getPackagingUnitImportCandidates();
  }

  getPackagingChangeCandidates(): Observable<ChangeCandidateDto[]> {
    return this.importExportApiService.getPackagingUnitTrackedChanges();
  }

  packagingImportCandidatesSeen(): Promise<any> {
    return this.importExportApiService.putPackagingUnitImportNotificationsSeen();
  }

  packagingChangeCandidatesSeen(): Promise<any> {
    return this.importExportApiService.putPackagingUnitTrackingtNotificationsSeen();
  }

  packagingImportCandidatesCountUpdate(): Promise<any> {
    return Promise.all([this.importExportApiService.updatePackagingUnitImportCount(),this.importExportApiService.updateComponentImportCount(),this.importExportApiService.updateMaterialImportCount()]);
  }

  packagingChangeCandidatesCountUpdate(): Promise<any> {
    return Promise.all([this.importExportApiService.updatePackagingSystemTrackingCount(),this.importExportApiService.updateComponentTrackingCount(),this.importExportApiService.updateMaterialTrackingCount()]);
  }

  getDeleteFunction(importType: ImportTypeSetting): (candidate: number) => Observable<any> {
    if (importType === ImportTypeSetting.Import) {
      return this.getDeleteFunctionImportCandidate();
    }
    return this.getDeleteFunctionChangeCandidate();
  }

  getImportFunctionImportCandidate(): (candidateId: number, targetDirId: number, isWithTracking: boolean) => Observable<any> {
    return (candidateId: number, targetDirId: number, isWithTracking: boolean) => this.importExportApiService.importPackagingUnit(candidateId, targetDirId, isWithTracking);
  }

  getChangeFunctionChangeCandidate(): (changeId: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.applyPackagingUnitChanges(changeId);
  }

  getPackagingIdsFromChangeCandidates(selectedChanges: ChangeCandidateDto[]): number[] {
    return selectedChanges.map(x => (x as ChangePackagingUnitCandidateDto).existingPackagingUnit.id ?? -1).filter(x => x !== -1);
  }

  navigateToCandidate(candidate: ImportCandidateDto): void {
    this.packagingUnitNavigationService.navigateToPackagingUnitPreview(candidate.id);
  }

  navigateToChange(candidate: ChangeCandidateDto, seePackagingBeforeChange: boolean): void {
    const change = candidate as ChangePackagingUnitCandidateDto;
    const id = seePackagingBeforeChange ? change.existingPackagingUnit.id : change.importCandidateId;
    if (id == null) {
      return;
    }
    this.packagingUnitNavigationService.navigateToPackagingUnitPreview(id, true, seePackagingBeforeChange);
  }

  private getDeleteFunctionImportCandidate(): (candidate: number) => Observable<any> {
    return (candidateId: number) => this.importExportApiService.deletePackagingUnitImportCandidate(candidateId);
  }

  private getDeleteFunctionChangeCandidate(): (candidate: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.ignorePackagingUnitChanges(changeId);
  }
}
